import { render, staticRenderFns } from "./DataStepFour.vue?vue&type=template&id=12a9fdca&scoped=true&"
import script from "./DataStepFour.vue?vue&type=script&lang=js&"
export * from "./DataStepFour.vue?vue&type=script&lang=js&"
import style0 from "./DataStepFour.vue?vue&type=style&index=0&id=12a9fdca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9fdca",
  null
  
)

export default component.exports